import React from 'react';
import { AlertTriangle } from 'lucide-react';

export interface ConflittoOrario {
    tipo: 'INCARICO' | 'TURNO' | string;
    id: number;
    descrizione?: string;
    data?: string;
    oraInizio?: string;
    oraFine?: string;
    overridable?: boolean;
}

export interface EsitoConflitti {
    message: string;
    conflicts: ConflittoOrario[];
    overridable: boolean;
}

// Il 409 per sovrapposizione arriva come { data: { conflicts, overridable } } dagli incarichi
// e come { conflicts, overridable } dai turni.
export const estraiConflitti = (e: any): EsitoConflitti | null => {
    const body = e?.response?.data;
    if (e?.response?.status !== 409 || !body) return null;
    const src = Array.isArray(body?.data?.conflicts) ? body.data : body;
    if (!Array.isArray(src?.conflicts) || src.conflicts.length === 0) return null;
    return {
        message: body.message || 'Il collaboratore è già impegnato nel nuovo orario.',
        conflicts: src.conflicts,
        overridable: !!src.overridable,
    };
};

const fmtData = (d?: string) => (d ? new Date(d).toLocaleDateString('it-IT') : '');

export const ConflittiOrario: React.FC<{
    esito: EsitoConflitti;
    conferma: boolean;
    onConferma: (v: boolean) => void;
}> = ({ esito, conferma, onConferma }) => (
    <div className="rounded-lg border border-amber-300 bg-amber-50 p-3 text-xs text-amber-900 space-y-2">
        <div className="flex items-center gap-1.5 font-bold">
            <AlertTriangle size={14}/> {esito.message}
        </div>
        <ul className="list-disc pl-5 space-y-0.5">
            {esito.conflicts.map(c => (
                <li key={`${c.tipo}-${c.id}`}>
                    {c.tipo === 'TURNO' ? 'Turno' : 'Incarico'}{c.descrizione ? `: ${c.descrizione}` : ''}
                    {c.data ? ` · ${fmtData(c.data)}` : ''}{c.oraInizio ? ` ${c.oraInizio}–${c.oraFine || '?'}` : ''}
                </li>
            ))}
        </ul>
        {esito.overridable ? (
            <label className="flex items-start gap-2 font-bold cursor-pointer">
                <input type="checkbox" className="mt-0.5" checked={conferma} onChange={e => onConferma(e.target.checked)}/>
                Gli impegni sovrapposti risultano già chiusi: confermo di salvare comunque il nuovo orario.
            </label>
        ) : (
            <p className="font-bold">Non si può salvare: libera prima il collaboratore o scegli un altro orario.</p>
        )}
    </div>
);
